module.exports = __webpack_public_path__ + "img/icon_map_38_off_101.a898e7bd.png";